import { useDispatch } from 'react-redux';
import { Action } from 'redux-saga';
import { useEffect } from 'react';
import { message } from 'antd';
import { useBusiness } from '../../../store/business';
import { getMessageInError } from '../../../hooks/fetch';
import {
  businessListClear,
  businessListErrorClear,
  businessListGet,
  BusinessListGetParams,
} from '../../../store/business/list';

const useBusinessList = () => {
  const dispatch = useDispatch();
  const { list } = useBusiness();

  const getBusinessList = (params: BusinessListGetParams) => {
    dispatch(businessListGet(params) as Action);
  };

  useEffect(() => () => {
    dispatch(businessListClear() as Action);
    dispatch(businessListErrorClear() as Action);
  }, []);

  useEffect(() => {
    if (list.error) {
      message
        .error(getMessageInError(list.error))
        .then(() => dispatch(businessListErrorClear() as Action));
    }
  }, [list.error]);

  const clearBusinessById = () => {
    dispatch(businessListClear() as Action);
    dispatch(businessListErrorClear() as Action);
  };

  return {
    getBusinessList, clearBusinessById, response: list.response, error: list.error, loading: list.loading,
  };
};

export default useBusinessList;
